import { Button } from '@codeparva/ui-components-library';
import React from 'react';
import { weakKey } from '../../../utilities/weakKey';
import { unitCardSectionConfig } from '../UnitCardConfig';
import { UnitCardTypes } from '../UnitCardTypes';
import { navigate } from 'gatsby';
import { useSectionData } from '../../../sections/rentalPage/components/dynamicForm/hooks/dataContext';

export const GetTableData = ({
  showSelectedUnit,
  unitCardsConfig,
  unitsData,
  foundData,
  onSetIndividualData,
}: UnitCardTypes.TTableTypes) => {
  const {
    show,
    label,
  } = unitCardsConfig.unitTypeModal.modalHeaderDetails.callToAction;
  const {
    individualUnitDataContext: { selectedUnitData },
  } = useSectionData();
  const getEnabled = (type: string, tfw: UnitCardTypes.TTFW) => {
    if (type === 'move-in' && tfw && tfw.move_in) {
      const {
        move_in: { is_enabled },
      } = tfw;
      return is_enabled;
    } else if (type === 'reservation' && tfw && tfw.reservation) {
      const {
        reservation: { is_enabled },
      } = tfw;
      return is_enabled;
    }
    return false;
  };

  const clickHandler = (item: UnitCardTypes.TUnitData) => {
    showSelectedUnit(item.unitTypeID);
    onSetIndividualData(item);
    selectedUnitData &&
      navigate('../bev', {
        state: {
          individualUnitTypeData: item,
          clickedPath: 'move-in',
        },
      });
  };

  const isEnabled = (isEnabledMoveIn: any, isEnabledReservation: any) =>
    isEnabledMoveIn && isEnabledReservation;

  return (
    <>
      {unitsData.unitTypeData.map((item: UnitCardTypes.TUnitData) => {
        const {
          vacantUnitsCount: { total_count },
          tfw,
        } = item ?? item;
        const isEnabledMoveIn = getEnabled('move-in', tfw);
        const isEnabledReservation = getEnabled('reservation', tfw);
        const isMatchingUnitId = item.unitTypeID === foundData.unitTypeID;
        const isEmptyUnit =
          total_count >= 1 && isEnabled(isEnabledMoveIn, isEnabledReservation);
        if (!isMatchingUnitId && isEmptyUnit) {
          return (
            <tbody className="tableBody" key={weakKey(item)}>
              <tr className="tableBodyRow">
                <td className="unitTypeNameAndCategory is-hidden-tablet">
                  <div className="unitTypeName">
                    <span>{item.unitTypeName}</span>
                  </div>
                  <div className="unitTypeCategory">
                    <span>{item.unitTypeCategory || 'Regular'}</span>
                  </div>
                </td>
                <td className="unitTypeNameBody is-hidden-mobile">
                  {item.unitTypeName}
                </td>
                <td className="unitTypeCategoryBody is-hidden-mobile">
                  {item.unitTypeCategory || 'Regular'}
                </td>
                <td className="has-text-left priceData">
                  {unitCardSectionConfig.currencyCode}{' '}
                  {(typeof item.unitTypeRate.Month === 'string'
                    ? parseInt(item.unitTypeRate.Month!)
                    : (item.unitTypeRate.Month as number)) +
                    parseInt(item.fee.deposit) +
                    parseInt(item.fee.setup)}
                </td>
                <td className="has-text-left clickHereButtonBody">
                  {show && (
                    <Button
                      className="cp-primary-button-highlighted has-text-white has-text-centered clickHereButton"
                      rounded
                      fullwidth
                      size="small"
                      type="button"
                      onClick={() => {
                        clickHandler(item);
                      }}
                    >
                      {label}
                    </Button>
                  )}
                </td>
              </tr>
            </tbody>
          );
        }
      })}
    </>
  );
};
export const DisplayModal = ({
  unitCardsConfig,
  showModal,
  height,
  showSelectedUnit,
  unitsData,
  foundData,
  onSetIndividualData,
  showModalTable,
}: UnitCardTypes.TModalData) => {
  const { title, modalHeaderDetails } = unitCardsConfig.unitTypeModal;
  const { header } = modalHeaderDetails;
  return (
    <div
      className={`modal unitCardModal py-6 ${showModal && 'is-active'}`}
      style={{
        marginTop: height,
      }}
    >
      <div className="modal-background unitCardModalBackground" />
      <div className="modal-card unitCardModalCard">
        <header className="modal-card-head unitCardModalHeader">
          <p className="modal-card-title unitCardModalTitle">
            {title} &nbsp;&nbsp;
          </p>
          <button
            type="button"
            className="delete is-large unitCardCrossButton"
            aria-label="close"
            onClick={() => {
              showModalTable();
            }}
          ></button>
        </header>
        <div className="modal-card-body unitCardModalBody">
          <table className="table unitTypeModalTable is-hoverable is-fullwidth">
            <thead className="tableHeader">
              <tr className="tableHeaderRow">
                <th className="unitTypeName is-hidden-mobile">
                  {header.RowOne}
                </th>
                <th className="unitTypeCategory is-hidden-mobile">
                  {header.RowTwo}
                </th>
                <th className="unitTypeNameAndCategory is-hidden-tablet">
                  {header.RowOneForTablet}
                </th>
                <th className="has-text-left unitTypePrice">
                  {header.RowThree}
                </th>
                <th></th>
              </tr>
            </thead>
            <GetTableData
              showSelectedUnit={showSelectedUnit}
              unitCardsConfig={unitCardsConfig}
              unitsData={unitsData}
              foundData={foundData}
              onSetIndividualData={onSetIndividualData}
            />
          </table>
        </div>
        <footer className="modal-card-foot is-flex is-justify-content-center">
          <div className="unitTypeFooterDiv"></div>
        </footer>
      </div>
    </div>
  );
};
